import { render } from "./list-inventory.vue?vue&type=template&id=6c417ce2&scoped=true"
import script from "./list-inventory.vue?vue&type=script&lang=js"
export * from "./list-inventory.vue?vue&type=script&lang=js"

import "./list-inventory.vue?vue&type=style&index=0&id=6c417ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c417ce2"]])

export default __exports__